
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class B2CGstReportSummaryDialog extends Serenity.EntityDialog<B2CGstReportSummaryRow, any> {
        protected getFormKey() { return B2CGstReportSummaryForm.formKey; }
        protected getIdProperty() { return B2CGstReportSummaryRow.idProperty; }
        protected getLocalTextPrefix() { return B2CGstReportSummaryRow.localTextPrefix; }
        protected getNameProperty() { return B2CGstReportSummaryRow.nameProperty; }
        protected getService() { return B2CGstReportSummaryService.baseUrl; }
        protected getDeletePermission() { return B2CGstReportSummaryRow.deletePermission; }
        protected getInsertPermission() { return B2CGstReportSummaryRow.insertPermission; }
        protected getUpdatePermission() { return B2CGstReportSummaryRow.updatePermission; }

        protected form = new B2CGstReportSummaryForm(this.idPrefix);

    }
}